module.exports = __webpack_public_path__ + "static/img/Luke-Laulilli.62ee3e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Laulilli.jpg
// module id = +Cw6
// module chunks = 0